import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import StorageUnits from './components/StorageUnits';

const storageUnits = (props,{ t }) => (
  <Container>
    <StorageUnits {...props} />
  </Container>
);

storageUnits.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('common')(storageUnits);
